export default __webpack_public_path__ + "static/media/21.d80f0a11.png";